<mat-nav-list>

  @if (printButton$ | async) {
    <a href="javascript:void(0);" mat-list-item (click)="print()">
      <div matListItemTitle i18n>Print Waybills</div>
      <div matListItemLine>{{ (printableShipments$ | async).length }} selected</div>
    </a>
  }

  @if (shipButton$ | async) {
    <a href="javascript:void(0);" mat-list-item (click)="ship()">
      <div matListItemTitle i18n>Submit Shipments</div>
      <div matListItemLine>{{ (shippableShipments$ | async).length }} selected</div>
    </a>
  }

  @if (quoteButton$ | async) {
    <a href="javascript:void(0);" mat-list-item (click)="quote()">
      <div matListItemTitle i18n>Quote Shipments</div>
      <div matListItemLine>{{ (quotableShipments$ | async).length }} selected</div>
    </a>
  }

  @if (voidButton$ | async) {
    <a href="javascript:void(0);" mat-list-item (click)="voidShipment()">
      <div matListItemTitle i18n>Void Shipments</div>
      <div matListItemLine>{{ (voidableShipments$ | async).length }} selected</div>
    </a>
  }

  @if (pickupButton$ | async) {
    <a href="javascript:void(0);" mat-list-item (click)="pickup()">
      <div matListItemTitle i18n>Pickup Shipments</div>
      <div matListItemLine>{{ (pickupShipments$ | async).length }} selected</div>
    </a>
  }

  @if (cancelPickupButton$ | async) {
    <a href="javascript:void(0);" mat-list-item (click)="cancelPickup()">
      <div matListItemTitle i18n>Cancel Pickup Booking</div>
      <div matListItemLine>{{ (pickups$ | async).length }} selected</div>
    </a>
  }

</mat-nav-list>
